import {
    MARKETS_ALL_REQUEST,
    MARKETS_ALL_SUCCESS,
    MARKETS_ALL_FAIL,
    MARKETS_REQUEST,
    MARKETS_SUCCESS,
    MARKETS_FAIL,
    PRODUCTS_REQUEST,
    PRODUCTS_SUCCESS,
    PRODUCTS_FAIL,
    MARKET_LOG_REQUEST,
    MARKET_LOG_SUCCESS,
    MARKET_LOG_FAIL,
    SHOW_ONLINE_MARKET_LOG_LIST,
    SHOW_ONLINE_MARKET_LOG_GRID,
    HIDE_ONLINE_MARKET_LOG,
    SHOW_POPUP,
    SHOW_BID_POPUP,
    HIDE_BID_POPUP,
    UPDATE_BID,
    UPDATING_MARKET,
    UPDATING_PRODUCT,
    HIDE_PRODUCT,
    SHOW_PROGRESS,
    HIDE_PROGRESS,
    MARKET_LOG_STORE_ARGS,
    MARKET_LOG_SET_SELECTED_VIEW,
    SHOW_MANAGE_MARKET_POPUP,
    HIDE_MANAGE_MARKET_POPUP,
    SHOW_MANAGE_PRODUCT_POPUP,
    HIDE_MANAGE_PRODUCT_POPUP,
    HIDE_TAB,
    SHOW_STATUSBAR,
    HIDE_STATUSBAR,
    STORE_STATUSBAR_DATA,
    CLEAN_STATUSBAR_DATA,
    SHOW_MARKETLOG_FILTER,
    HIDE_MARKETLOG_FILTER,
    GET_CUSTOM_VIEW_REQUEST,
    GET_CUSTOM_VIEW_SUCCESS,
    GET_CUSTOM_VIEW_FAIL,
    SAVE_VIEW_REQUEST,
    SAVE_VIEW_SUCCESS,
    SAVE_VIEW_FAIL,
    DELETE_VIEW_REQUEST,
    DELETE_VIEW_SUCCESS,
    DELETE_VIEW_FAIL,
    STORE_FREIGHTS,
    ADD_MARKET_ORDER_NOTIFIKATION,
    REMOVE_MARKET_ORDER_NOTIFIKATION,
} from '../constants/action-types';

import { errorMessages } from '../constants/errorMessages';
import { getBidPopupText } from '../services/utils';

import {
    getMarketsRequest,
    getProductsRequest,
    getMarketLogRequest,
    placeBidRequest,
    getMarketsAllRequest,
    killRelatedToUserAndOpenByScope,
    manageMarketRequest,
    deleteMarketRequest,
    manageProductRequest,
    hideProductRequest,
    deleteProductRequest,
    getLatestIndexRequest,
    getCustomViewsRequest,
    saveCustomViewRequest,
    deleteCustomViewRequest,
    getShowableFreights,
    getOrderRequest,
    hideCustomViewRequest,
} from '../services/api';

import { autoLogin } from './userActions';

import { CustomViewType } from '../constants/customViews';

export function getMarketsList() {
    return dispatch => {
        dispatch({
            type: MARKETS_REQUEST,
        });
        getMarketsRequest()
            .then(result => {
                dispatch({
                    type: MARKETS_SUCCESS,
                    payload: result.data,
                });
            })
            .catch(error => {
                dispatch({
                    type: MARKETS_FAIL,
                    error,
                });
            });
    };
}

export function getProductsList() {
    return dispatch => {
        dispatch({
            type: PRODUCTS_REQUEST,
        });
        getProductsRequest()
            .then(result => {
                dispatch({
                    type: PRODUCTS_SUCCESS,
                    payload: result.data,
                });
            })
            .catch(error => {
                dispatch({
                    type: PRODUCTS_FAIL,
                    error,
                });
            });
    };
}

export function getMarketLog(params) {
    return dispatch => {
        dispatch({
            type: MARKET_LOG_REQUEST,
            params,
        });
        getMarketLogRequest(params)
            .then(result => {
                if (Array.isArray(result.data)) {
                    dispatch({
                        type: MARKET_LOG_SUCCESS,
                        payload: result.data,
                    });
                }
            })
            .catch(error => {
                dispatch({
                    type: MARKET_LOG_FAIL,
                    error,
                });
            });
    };
}

function checkIfExpired(dispatch, order, shouldReopenOrder) {
    if (order.expiry_time && new Date(order.expiry_time) <= new Date()) {
        dispatch(hideBidPopup());
        dispatch({
            type: SHOW_POPUP,
            popupProps: {
                title: 'ERROR',
                content: 'This order has just expired',
                buttonAction: shouldReopenOrder ? () => dispatch(placeOrder(order)) : () => {},
            },
        });
    }
}

function orderTradedOrDeleted(dispatch) {
    dispatch(hideBidPopup());
    dispatch({
        type: SHOW_POPUP,
        popupProps: {
            title: 'ERROR',
            content: 'The order is no longer available or has already traded.',
        },
    });
}

export function updateOrderIfOpen(orderId) {
    return (dispatch, getState) => {
        const { isBidPopupVisible, bidFormData, updatingBid } = getState().markets;
        const { isPopupVisible, popupProps } = getState().app;
        const { isAdmin, isSuperUser } = getState().user;
        const isUserBidding = isBidPopupVisible && bidFormData.id === orderId && !updatingBid;
        const isUserOnCallUs = isPopupVisible && popupProps.customType && popupProps.customType === 'CallUs';

        if (isUserBidding || isUserOnCallUs) {
            getOrderRequest(orderId)
                .then(result => {
                    const order = result.data;
                    if (order.status === 'CLOSED') {
                        orderTradedOrDeleted(dispatch);
                        return;
                    }
                    dispatch(hideBidPopup());
                    if (order.type === 'Regular' || isAdmin || isSuperUser) {
                        dispatch(placeOrder(order));
                        dispatch({
                            type: SHOW_POPUP,
                            popupProps: {
                                title: 'INFO',
                                content:
                                    'This order has recently been changed. Press OK to see updated order information, before confirming your trade',
                            },
                        });
                    } else if (isUserBidding) {
                        dispatch({
                            type: SHOW_POPUP,
                            popupProps: {
                                title: 'INFO',
                                content:
                                    'This order has recently been changed. Press OK to see updated order information, before confirming your trade',
                                buttonAction: () => setTimeout(() => dispatch(callDH(order)), 100),
                            },
                        });
                    } else {
                        dispatch(callDH(order));
                    }
                })
                .catch(error => {
                    const { status, data } = error.response;
                    if (status === 404) {
                        orderTradedOrDeleted(dispatch);
                    }
                });
        }
    };
}

export function placeOrder(data) {
    return (dispatch, getState) => {
        const { isAdmin, isSuperUser } = getState().user;
        let expirationInterval = null;
        if (data.status === 'OPEN' && data.expiry_time && new Date(data.expiry_time) > new Date()) {
            expirationInterval = setInterval(() => checkIfExpired(dispatch, data, isAdmin || isSuperUser), 1000);
        }
        dispatch({
            type: SHOW_BID_POPUP,
            formData: data,
            expirationInterval,
        });
    };
}

export function callDH(data) {
    return {
        type: SHOW_POPUP,
        popupProps: {
            title: 'CONTACT US',
            customType: 'CallUs',
            customParams: data,
        },
    };
}
export function hideBidPopup() {
    return {
        type: HIDE_BID_POPUP,
    };
}

export function updateBid(title, formData, popupTextAfterParams) {
    return dispatch => {
        dispatch({ type: UPDATE_BID });
        dispatch({ type: SHOW_PROGRESS });
        placeBidRequest(formData)
            .then(result => {
                dispatch({ type: HIDE_PROGRESS });
                dispatch({ type: HIDE_BID_POPUP });

                popupTextAfterParams[0] = Object.assign({}, popupTextAfterParams[0], formData, result.data);
                dispatch({
                    type: SHOW_POPUP,
                    popupProps: {
                        title,
                        content: getBidPopupText(...popupTextAfterParams),
                    },
                });
            })
            .catch(error => {
                const { status, data } = error.response;
                dispatch({ type: HIDE_PROGRESS });
                dispatch({ type: HIDE_BID_POPUP });

                if (status === 419 || status === 420) {
                    dispatch({
                        type: SHOW_POPUP,
                        popupProps: {
                            title: 'Error',
                            content: errorMessages[status.toString()],
                        },
                    });
                }
            });
    };
}

export function showOnlineMarketLog(view_type) {
    if (view_type === 'list') {
        return {
            type: SHOW_ONLINE_MARKET_LOG_LIST,
        };
    }
    return {
        type: SHOW_ONLINE_MARKET_LOG_GRID,
    };
}

export function hideOnlineMarketLog() {
    return {
        type: HIDE_ONLINE_MARKET_LOG,
    };
}

export function storeMarketLogArgs(payload) {
    return {
        type: MARKET_LOG_STORE_ARGS,
        payload,
    };
}
export function setSelectedView(payload) {
    return {
        type: MARKET_LOG_SET_SELECTED_VIEW,
        payload,
    };
}

// Managing markets

export function getMarketsAllList() {
    return dispatch => {
        getMarketsAllListRefresh(dispatch);
    };
}

export function manageMarket(mode, data, clearForm) {
    return dispatch => {
        dispatch({ type: SHOW_PROGRESS });
        dispatch({ type: UPDATING_MARKET });
        manageMarketRequest(mode, data)
            .then(result => {
                dispatch({ type: HIDE_PROGRESS });
                dispatch({ type: HIDE_MANAGE_MARKET_POPUP });
                getMarketsAllListRefresh(dispatch);
                if (typeof clearForm === 'function') clearForm();
            })
            .catch(error => {
                dispatch({ type: HIDE_PROGRESS });
                console.log(error);
            });
    };
}

export function deleteMarket(id, name) {
    return dispatch => {
        dispatch({
            type: SHOW_POPUP,
            popupProps: {
                title: 'Delete market!',
                content: `You are about to delete ${name} - Do you wish to proceed?`,
                isConfirm: true,
                buttonAction: () => {
                    dispatch({ type: SHOW_PROGRESS });
                    dispatch({ type: UPDATING_MARKET });
                    deleteMarketRequest(id)
                        .then(result => {
                            dispatch({ type: HIDE_PROGRESS });
                            getMarketsAllListRefresh(dispatch);
                        })
                        .catch(error => {
                            dispatch({ type: HIDE_PROGRESS });
                            console.log(error);
                        });
                },
            },
        });
    };
}

export function showManageMarketPopup(mode, data) {
    return {
        type: SHOW_MANAGE_MARKET_POPUP,
        mode,
        data: mode == 'update' ? data : {},
    };
}
export function hideManageMarketPopup() {
    return {
        type: HIDE_MANAGE_MARKET_POPUP,
    };
}

// Managing products

export function manageProduct(mode, data, refreshUsers, clearForm) {
    return dispatch => {
        dispatch({ type: SHOW_PROGRESS });
        dispatch({ type: UPDATING_PRODUCT });
        manageProductRequest(mode, data)
            .then(result => {
                dispatch({ type: HIDE_PROGRESS });
                refreshUsers(() => {
                    dispatch({ type: HIDE_MANAGE_PRODUCT_POPUP });
                    clearForm();
                });
            })
            .catch(error => {
                dispatch({ type: HIDE_PROGRESS });
                dispatch({
                    type: SHOW_POPUP,
                    popupProps: {
                        title: 'ERROR',
                        content: (error.response && error.response.data) || error,
                    },
                });
                console.log(error);
            });
    };
}

export function deleteProduct(id, name, refreshUsers) {
    return dispatch => {
        dispatch({
            type: SHOW_POPUP,
            popupProps: {
                title: 'Delete product!',
                content: `You are about to delete ${name} - Do you wish to proceed?`,
                isConfirm: true,
                buttonAction: () => {
                    dispatch({ type: SHOW_PROGRESS });
                    dispatch({ type: UPDATING_PRODUCT });
                    deleteProductRequest(id)
                        .then(result => {
                            dispatch({ type: HIDE_PROGRESS });
                            refreshUsers();
                        })
                        .catch(error => {
                            dispatch({ type: HIDE_PROGRESS });
                            console.log(error);
                        });
                },
            },
        });
    };
}
export function hideProduct(id, hidden, refreshUsers) {
    return dispatch => {
        dispatch({ type: SHOW_PROGRESS });
        dispatch({ type: HIDE_PRODUCT });
        const data = { hidden };
        hideProductRequest(id, data)
            .then(result => {
                dispatch({ type: HIDE_PROGRESS });
                getMarketsAllListRefresh(dispatch);
                refreshUsers();
            })
            .catch(error => {
                dispatch({ type: HIDE_PROGRESS });
                dispatch({
                    type: SHOW_POPUP,
                    popupProps: {
                        title: 'ERROR',
                        content: (error.response && error.response.data) || error,
                    },
                });
                console.log(error);
            });
    };
}

export function showManageProductPopup(mode, market_id, data) {
    return {
        type: SHOW_MANAGE_PRODUCT_POPUP,
        mode,
        market_id,
        data,
    };
}

export function hideManageProductPopup() {
    return {
        type: HIDE_MANAGE_PRODUCT_POPUP,
    };
}

export function hideTap(id, hidden) {
    return dispatch => {
        dispatch({ type: SHOW_PROGRESS });
        dispatch({ type: HIDE_TAB });
        const data = { hidden };
        hideCustomViewRequest(id, data)
            .then(result => {
                dispatch({ type: HIDE_PROGRESS });
                dispatch(autoLogin());
                dispatch(getCustomViews());
            })
            .catch(error => {
                dispatch({ type: HIDE_PROGRESS });
                dispatch({
                    type: SHOW_POPUP,
                    popupProps: {
                        title: 'ERROR',
                        content: (error.response && error.response.data) || error,
                    },
                });
            });
    };
}

const getMarketsAllListRefresh = dispatch => {
    dispatch({
        type: MARKETS_ALL_REQUEST,
    });
    return getMarketsAllRequest()
        .then(result => {
            dispatch({
                type: MARKETS_ALL_SUCCESS,
                payload: result.data,
            });
        })
        .catch(error => {
            dispatch({
                type: MARKETS_ALL_FAIL,
                error,
            });
        });
};

export function killOrders(scope) {
    return dispatch => {
        dispatch({ type: SHOW_PROGRESS });
        killRelatedToUserAndOpenByScope(scope)
            .then(result => {
                dispatch({ type: HIDE_PROGRESS });
                getMarketsAllList();
            })
            .catch(error => {
                dispatch({ type: HIDE_PROGRESS });
                dispatch({
                    type: SHOW_POPUP,
                    popupProps: {
                        title: 'ERROR',
                        content: (error.response && error.response.data) || error,
                    },
                });
                console.log(error);
            });
    };
}

// Custom views
// Not using at this moment:
export const getCustomViews = () => async dispatch => {
    dispatch({
        type: GET_CUSTOM_VIEW_REQUEST,
    });
    try {
        const result = await getCustomViewsRequest();

        dispatch({
            type: GET_CUSTOM_VIEW_SUCCESS,
            payload: result.data,
        });
    } catch (error) {
        dispatch({
            type: GET_CUSTOM_VIEW_FAIL,
            error,
        });
    }
};

export const saveCustomView =
    (mode, params, onSuccess, type = CustomViewType.LIST) =>
    async dispatch => {
        dispatch({
            type: SAVE_VIEW_REQUEST,
        });
        try {
            await saveCustomViewRequest(mode, params);

            dispatch({
                type: SAVE_VIEW_SUCCESS,
            });

            onSuccess();
            dispatch(autoLogin());
            dispatch({
                type: SHOW_POPUP,
                popupProps: {
                    title: 'Success',
                    content: `${type === CustomViewType.GRID ? 'Tab' : 'Customised'} view was saved`,
                },
            });
            dispatch(getCustomViews());
        } catch (error) {
            dispatch({
                type: SAVE_VIEW_FAIL,
                error,
            });

            const { data, status } = error.response;
            // TODO add to ajaxErrorsInterceptor
            if (status === 400) {
                dispatch({
                    type: SHOW_POPUP,
                    popupProps: {
                        title: 'Error',
                        content: JSON.stringify(data),
                    },
                });
            }
        }
    };

export function deleteCustomView(id, type = 'list') {
    const view_type = type === 'grid' ? 'tab' : 'customised';
    return dispatch => {
        dispatch({
            type: SHOW_POPUP,
            popupProps: {
                title: 'Are you sure',
                content: `Do you want to delete this ${view_type} view?`,
                isConfirm: true,
                buttonAction: () => {
                    dispatch({
                        type: DELETE_VIEW_REQUEST,
                    });
                    deleteCustomViewRequest(id)
                        .then(result => {
                            dispatch({
                                type: DELETE_VIEW_SUCCESS,
                            });
                            dispatch(autoLogin());
                            dispatch(getCustomViews());
                        })
                        .catch(error => {
                            dispatch({
                                type: DELETE_VIEW_SUCCESS,
                                error,
                            });
                        });
                },
            },
        });
    };
}

// Stauts bar

export function requestStatusbarData(product_id, params) {
    return dispatch => {
        getLatestIndexRequest(product_id)
            .then(result => {
                dispatch({
                    type: STORE_STATUSBAR_DATA,
                    product_id,
                    params,
                    payload: result.data,
                });
            })
            .catch(error => {
                dispatch({
                    type: CLEAN_STATUSBAR_DATA,
                });
                console.log(error);
            });
    };
}

export function requestFreights() {
    return dispatch => {
        getShowableFreights()
            .then(result => {
                dispatch({
                    type: STORE_FREIGHTS,
                    payload: result.data,
                });
            })
            .catch(error => {
                console.log(error);
            });
    };
}

export function showStatusbar() {
    return {
        type: SHOW_STATUSBAR,
    };
}

export function hideStatusbar() {
    return {
        type: HIDE_STATUSBAR,
    };
}

export function marketOrderNotifikation(product_id) {
    return {
        type: ADD_MARKET_ORDER_NOTIFIKATION,
        payload: product_id,
    };
}

export function removeMarketOrderNotifikation() {
    return {
        type: REMOVE_MARKET_ORDER_NOTIFIKATION,
    };
}

// Filter

export function showMarketlogFilter(filterType, data) {
    return {
        type: SHOW_MARKETLOG_FILTER,
        params: {
            type: filterType,
            data,
        },
    };
}

export function hideMarketlogFilter() {
    return {
        type: HIDE_MARKETLOG_FILTER,
    };
}



// WEBPACK FOOTER //
// ./source/actions/marketsActions.js